/**
 * Parse <meta> options from document
 * @function
 * @return {object} key/value pairs of <meta> elements
 */
export default function getOptionsFromMetaTags() {
  if (!document) {
    // return if not in a browser context
    return;
  }
  // @ts-ignore
  var options = Array.from(document.getElementsByTagName('meta')).filter(function (el) {
    return el.name && el.name.slice(0, 1) === '_';
  }).reduce(function (prev, next) {
    var key = next.name;
    var value = next.content;
    if (next.dataset.type === 'json') {
      try {
        value = JSON.parse(next.content);
      } catch (e) {
        console.error("Failed parsing <meta name=\"".concat(key, "\" content=\"").concat(value, "\"> as JSON"));
      }
    }
    prev[key.slice(1)] = value;
    return prev;
  }, {});
  if (!options.rootPath) {
    options.rootPath = "".concat(options.contextPath, "/").concat(options.orgContext, "/").concat(options.loginContext, "/app/");
  }
  return options;
}